import { SearchspringFetcher } from 'libs/searchspring/classes/searchspring-fetcher'
import { normaliseBlogResults } from 'libs/searchspring/helpers/normalisers'
import { generateSearchspringProvider } from 'libs/searchspring/fetchers/provider'

export class SearchspringBlog extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/search.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { handle, originalQuery, sort, filters, page, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('bgfilter.blog_handle', handle)

    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)

    if (sort) this.params.setSort(sort)
    else this.params.clearSort()
    if (filters) this.params.setFilters(filters)

    super.updateParams()
  }
}

export class SearchspringBlogSearch extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/search.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { query, resultsPerPage } = options
    if (!query || query === 'null') return

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('q', query)

    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)

    super.updateParams()
  }
}

const blogNormaliser = async (results) => {
  const normalisedResults = await normaliseBlogResults(results.results)
  return { ...results, results: normalisedResults }
}

export const SearchspringBlogProvider = generateSearchspringProvider(SearchspringBlog, blogNormaliser)
export const SearchspringBlogSearchProvider = generateSearchspringProvider(SearchspringBlogSearch, blogNormaliser)
